import React from 'react';
import { BiChevronRight } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { UIPrepPlan } from 'types';

interface Props {
	prepPlan: UIPrepPlan;
}

const BannerLeftSection = ({ prepPlan }: Props) => {
	const navigate = useNavigate();
	return (
		<div>
			<div className="flex items-center gap-[16px]">
				<button
					className="text-[14px] font-[500] leading-[20px] dark:text-[#E5F0FF] text-[#111E2C] font-inter"
					onClick={() => navigate('/challenges')}
				>
					Challenges
				</button>
				<BiChevronRight />
				<p className="text-[14px] font-[500] leading-[20px] dark:text-[#EBEBF0] text-[#1F3343] font-inter">
					{prepPlan.prepPlanTemplate.title}
				</p>
			</div>
			<div className="mt-[16px] flex gap-[16px]">
				<img
					className=" w-[60px] h-[60px] md:w-[72px] md:h-[72px]"
					src={prepPlan.prepPlanTemplate.logo}
					alt={prepPlan.prepPlanTemplate.title}
				/>
				<div className="">
					<h5 className="text-[18px] md:text-[24px] leading-[22px] md:leading-[30px] font-[700] dark:text-[#FAFAFC] text-[#1F3343] font-inter">
						{prepPlan.prepPlanTemplate.title}
					</h5>
					<div className="mt-[4px] flex items-center gap-[4px] ">
						<p className="text-[12px] md:text-[14px] font-[400] leading-[16px] md:leading-[20px] font-inter dark:text-[#F2F2F5] text-[#555770]">
							{prepPlan.days} <span className="dark:text-[#E5FFFF] text-[#8F90A6]">days</span>
						</p>
						{/* create a dot */}
						<div className="w-[4px] h-[4px] bg-[#C7C9D9] dark:bg-[#F2F2F5] rounded-full mx-[4px]"></div>
						<p className="text-[12px] md:text-[14px] font-[400] leading-[16px] md:leading-[20px] font-inter dark:text-[#F2F2F5] text-[#555770]">
							{prepPlan.totalProblems} <span className=" dark:text-[#E5FFFF] text-[#8F90A6]">problems</span>
						</p>
					</div>
					<p className="mt-[2px] text-[10px] md:text-[12px] font-[400] leading-[16px] font-inter dark:text-[#C7C9D9] text-[#555770]">
						{prepPlan.description}
					</p>
				</div>
			</div>
		</div>
	);
};

export default BannerLeftSection;
